<template>
  <div class="mine-content">
    <div class="mine-header"><span @click="util.goblack()" class="back">
        <img src="@/assets/images/base/icon_righ_g.png" /></span>Withdraw</div>
    <div class="second-pard">
      <div class="xzje" style="font-weight:bold;">Current Available Balance</div>
      <input class="money" v-model="userInfo.money" disabled />
      <div class="xzje" style="font-weight:bold;">Enter Withdrawal Amount
        <button class="mywallet" @click="setMoney()">All Cash</button>
      </div>
      <input class="money" v-model="money" />
      <div class="xzje" style="font-weight:bold;">Select Wallet
        <button class="mywallet" @click="util.topage('/wallet')">Manage</button>
        <button class="mywallet" @click="getDigital()">Load Digital</button>
        <button class="mywallet" @click="getBank()">Load Bank</button>
      </div>
      <van-picker class="van_picker" toolbar-position="top" v-show="showBank" :columns="bankList" :default-index="0" show-toolbar title="Select Wallet" @cancel="onCancel" @confirm="onConfirm" confirm-button-text="OK" cancel-button-text="Cancel" />
      <input class="money" readonly v-model="adds" @click="showBank = true" />
      <div class="xzje" style="font-weight:bold;">Enter Fund Password</div>
      <input type="password" class="money" v-model="paypassword" />
      <div v-show="!showBank">
        <div class="xzje" style="color:red;font-weight:bold;">Withdraw Prompt Information</div>
        <textarea class="money errerinfo" readonly v-model="errorInfo"></textarea>
        <button class="btn-submit" v-show="!showloding" @click="submitbtn">Submit</button>
        <button class="btn-submit" v-show="showloding">Submit</button>
      </div>
    </div>

    <div class="remark">
      <p>1. Withdraw time period {{ withdraw_period }}</p>
      <p>2. Withdraw {{ withdraw_times }} times for a day</p>
      <p>3. Amount range {{ min_withdraw }} - {{ max_withdraw }}</p>
    </div>

    <van-loading v-show="showloding" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
import { Picker } from 'vant';
Vue.use(Picker);
export default {
  data() {
    return {
      showloding: false,
      userInfo: this.util.user,
      money: 100,
      paypassword: "",
      showBank: false,
      adds: "",
      bankList: [],
      errorInfo: "",
      bank_id: 0,
      withdraw_times: 3,
      withdraw_period: '7/24 09:00-21:00',
      min_withdraw: 200,
      max_withdraw: 200000,
      wallet_type:4
    };
  },
  methods: {
    findConfigs() {
      this.axios.get(this.api.api_findConfigs, {
        params: { names: "withdraw_times_one_day,withdraw_period,min_withdraw,max_withdraw" },
      }).then((res) => {
          if (res.data.code == 0) {
            this.withdraw_times = res.data.data.withdraw_times_one_day;
            this.withdraw_period = res.data.data.withdraw_period;
            this.min_withdraw = res.data.data.min_withdraw;
            this.max_withdraw = res.data.data.max_withdraw;
          }
        })
    },
    setMoney() {
      this.money = Math.trunc(this.userInfo.money);
    },
    submitbtn() {
      let re = /[^\d]/g;
      if (!this.money) {
        this.errorInfo = "Amount cannot be blank";
      } else if (re.test(this.money)) {
        this.errorInfo = "Amount can only be a positive integer";
      } else if (this.money > this.userInfo.money) {
        this.errorInfo = "Insufficient balance";
      } else if (!this.adds) {
        this.errorInfo = "Please select wallet";
      } else if (!this.paypassword) {
        this.errorInfo = "Please enter your fund password";
      } else if (!this.showloding) {
        this.errorInfo = "Withdraw is being submitted...";
        this.saveWithdraw();
      }
    },
    saveWithdraw() {
      let params = {
        money: this.money,
        wallet_id: this.bank_id,
        withdrawType: this.wallet_type,
        password: this.md5.md5_hex_utf8(this.paypassword)
      };
      this.util.setDnValueUser(params);
      this.axios.post(this.api.api_withdraw, this.util.encodeSearchParams(params)).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          this.util.goblack();
          this.errorInfo = "Withdraw request submitted";
        } else {
          this.errorInfo = res.data.message;
        }
      }).catch(() => {
          this.showloding = false;
          this.errorInfo = "Withdraw failed";
        });
    },
    onCancel() {
      this.showBank = false;
    },
    onConfirm(value) {
      this.adds = value.text;
      this.bank_id = value.value
      this.showBank = false;
    },
    getBank() {
      this.adds="";
      this.wallet_type=4;
      this.showloding = true;
      let params = {}
      this.util.setDnValueUser(params);
      this.axios.get(this.api.api_getBankWallet, { params: params }).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          this.bankList = [];
          res.data.data.forEach(item => {
            this.bankList.push({
              text: item.bank_name + ":" + item.bank_card_number,
              value: item.id
            });
          });
        } else {
          this.util.checkToken(res.data.message);
        }
      });
    },
    getDigital() {
      this.adds="";
      this.wallet_type=3;
      this.showloding = true;
      let params = {}
      this.util.setDnValueUser(params);
      this.axios.get(this.api.api_getDigitalWallet, { params: params }).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          this.bankList = [];
          res.data.data.forEach(item => {
            this.bankList.push({
              text: item.type_1==item.type_2?(item.type_1 + ":" + item.wallet_url):(item.type_1 + ":" + item.type_2+":"+item.wallet_url),
              value: item.id
            });
          });
        } else {
          this.util.checkToken(res.data.message);
        }
      });
    },
  },
  activated() {
    if (!this.util.isLogin()) this.util.topage('login');
    this.util.refreshUserInfo((res) => this.userInfo = res);
    this.errorInfo = "";
    this.money = "";
    this.adds = "";
    this.paypassword = "";
    this.getBank();
    this.findConfigs();
  }
};
</script>
<style lang="scss" scoped>
.mine-content {
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  font-size: 0.34rem;
  background: rgb(235, 235, 235);
  color: black;
  width: 100%;
  height: 100%;

  .remark {
    width: 96%;
    background: white;
    margin: auto;
    padding: 5px 10px;
    border-radius: 10px/10px;
    margin-top: 6px;

    p {
      color: black;
      font-size: 0.32rem;
    }

  }

  .van_picker {
    background-color: rgb(164, 194, 219);
    width: 100%;
    border-radius: 10px/10px;
  }

  .mine-header {
    font-weight: bold;
    height: 1rem;
    display: grid;
    grid-template-columns: 30% 1fr 30%;
    align-items: center;
    text-align: center;

    .back {
      cursor: pointer;

      img {
        display: block;
        margin-left: 5%;
        width: 0.5rem;
        transform: rotate(180deg);
      }
    }
  }

  .second-pard {
    width: 96%;
    background: white;
    margin: auto;
    padding: 5px 5px;
    border-radius: 10px/10px;

    .xzje {
      padding-top: 4px;
      padding-bottom: 5px;
      padding-left: 5px;
      color: black;
    }

    ul {
      cursor: pointer;
      display: grid;
      grid-template-columns: 25% 25% 25% 25%;
      justify-items: center;

      // padding: 10px 0;
      button {
        border-radius: 5px/5px;
        margin: 5px auto;
        padding: 4px 0;
        width: 2.2rem;
        color: black;
        border: 1px solid rgb(232, 234, 237);
      }

      .on,
      button:hover {
        background: #628808;
        color: white;
      }
    }

    .money {
      width: 98.5%;
      height: 1rem;
      border-radius: 5px/5px;
      color: black;
      border: 1px solid rgb(232, 234, 237);
      margin: 5px 2px;
      padding: 0 10px;
    }

    .mywallet {
      background: #628808;
      color: white;
      float: right;
      margin-right: 5px;
      padding: 0 6px;
      font-size: 0.34rem;
      font-weight: normal;
      height: 25px;
    }

    .errerinfo {
      height: 2rem;
      padding-top: 4px;
      color: #f6543e;
      font-weight: bold;
      background-color: rgb(228, 222, 222);
      text-align: left;
      vertical-align: auto;
    }

    .btn-submit {
      margin: 5px auto;
      width: 100%;
      border-radius: 4px;
      font-size: 0.34rem;
      height: 40px;
      background: #628808;
      color: white;
    }

    .btn-submit:hover {
      background: #628808;
    }
  }
}
</style>